import { render, staticRenderFns } from "./CopyPanel.vue?vue&type=template&id=a214ac86&scoped=true"
import script from "./CopyPanel.vue?vue&type=script&lang=js"
export * from "./CopyPanel.vue?vue&type=script&lang=js"
import style0 from "./CopyPanel.vue?vue&type=style&index=0&id=a214ac86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a214ac86",
  null
  
)

export default component.exports